// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').Client} Client
 * @typedef {import('../types/system').DataClientIds} DataClientIds
 */

/**
 * @type {function(PlottrState): Client}
 */
const clientSelector = createSelector(fullSystemStateSelector, ({ client }) => {
  return client ?? {}
})
/**
 * @type {function(PlottrState): (String | Null)}
 */
export const userIdSelector = createSelector(clientSelector, ({ userId }) => userId)
/**
 * @type {function(PlottrState): (String | Null)}
 */
export const clientIdSelector = createSelector(clientSelector, ({ clientId }) => clientId)
/**
 * @type {function(PlottrState): (String | Null)}
 */
export const emailAddressSelector = createSelector(
  clientSelector,
  ({ emailAddress }) => emailAddress
)
/**
 * @type {function(PlottrState): (boolean | Null)}
 */
export const hasOnboardedSelector = createSelector(
  clientSelector,
  ({ hasOnboarded }) => hasOnboarded
)
/**
 * @type {function(PlottrState): boolean}
 */
export const isLoggedInSelector = createSelector(clientSelector, ({ isLoggedIn }) => !!isLoggedIn)
/**
 * @type {function(PlottrState): (boolean)}
 */
export const isOnWebSelector = createSelector(clientSelector, ({ isOnWeb }) => !!isOnWeb)
/**
 * @type {function(PlottrState): DataClientIds}
 */
const dataClientIdsSelector = createSelector(clientSelector, ({ dataClientIds }) => {
  return dataClientIds ?? {}
})
/**
 * @param {PlottrState} _state
 * @param {String} path
 * @return {String}
 */
const pathSelector = (_state, path) => {
  return path
}
/**
 * @type {function(PlottrState, String): (String | Null)}
 */
export const clientIdForPathSelector = createSelector(
  dataClientIdsSelector,
  pathSelector,
  (clientIds, path) => {
    return clientIds[path] ?? null
  }
)
export const currentAppStateIsDashboardSelector = createSelector(
  clientSelector,
  ({ legacy__currentAppState }) => {
    return legacy__currentAppState === 'DASHBOARD'
  }
)
